import { getOrigin } from 'ducks/origin';
import getRoutes from 'selectors/getRoutes';
import { createSelector } from 'reselect';

/**
 * Builds a full url (including origin) for a route. Excludes everything
 * after the first unique param (e.g. :id)
 * @todo: Is this still relevant, or can we replace it with toUrl.ts?
 * @param {String} route The route name, e.g. 'ACCEPT_INVITE'
 * @returns {Selector}
 */
const createGetUrl = route => createSelector(
  getOrigin,
  getRoutes,
  (origin, routes) => (
    `${origin.replace(/\/$/, '')}${routes[route].path.replace(/(:.*)/, '')}`
  ),
);

export default createGetUrl;
